export interface CostBreakdownResponse {
  base?: unknown;
  view?: unknown;
  access?: unknown;
  negotiate?: unknown;
}

export interface CostBreakdownItem {
  name: string;
  value: number;
}

const toCost = (value: unknown): number => {
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

// Payments calls the one-time creative publication charge `base`. That is an
// accounting key, not useful product copy. Keep it in the total under a human
// label instead of hiding a real amount from the organization.
export const buildCostBreakdown = (
  response: CostBreakdownResponse,
): { items: CostBreakdownItem[]; total: number } => {
  const values: CostBreakdownItem[] = [
    { name: "Cliques", value: toCost(response.access) },
    { name: "Anúncios publicados", value: toCost(response.base) },
    { name: "Visualizações", value: toCost(response.view) },
    { name: "Negociação", value: toCost(response.negotiate) },
  ];

  return {
    items: values.filter(({ value }) => value > 0),
    total: values.reduce((sum, { value }) => sum + value, 0),
  };
};
